import React from 'react';
import { Route } from 'react-router-dom';
import DashboardTemplate from 'src/templates/DashboardTemplate';
import ListWhatsappGroupsPage from 'src/pages/communication/whatsapp/ListWhatsappGroupsPage';
import ConfigWhatsappPage from 'src/pages/communication/whatsapp/ConfigWhatsappPage';
import ConfigBaileysPhonePage from 'src/pages/communication/whatsapp/ConfigBaileysPhonePage';
import AllowRole from 'src/components/AllowRole';
import AddWhatsappGroupPage from 'src/pages/communication/whatsapp/AddWhatsappGroupPage';

export default function CommunicationRoutes() {
	return (
		<Route path="/comunicacao" element={<AllowRole role={'admin'} />}>
			<Route path="whatsapp">
				<Route path="grupos">
					<Route path="listar" element={<ListWhatsappGroupsPage />} />
					<Route
						path="adicionar"
						element={
							<AddWhatsappGroupPage />
						}
					/>
				</Route>
				<Route path="configurar" element={<AllowRole role={'super_admin'} />}>
					<Route path="" element={<ConfigWhatsappPage />} />
				</Route>
				<Route path="telefone" element={<AllowRole role={'admin'} />}>
					<Route path="" element={<ConfigBaileysPhonePage />} />
				</Route>
			</Route>
			<Route
				path="telegram"
				element={<DashboardTemplate>Telegram</DashboardTemplate>}
			>
				<Route
					path="listar"
					element={
						<DashboardTemplate>Telegram listar</DashboardTemplate>
					}
				/>
				<Route
					path="adicionar"
					element={
						<DashboardTemplate>
                            Telegram adicionar
						</DashboardTemplate>
					}
				/>
				<Route
					path="configurar"
					element={
						<DashboardTemplate>
                            Telegram configurar
						</DashboardTemplate>
					}
				/>
			</Route>
			<Route
				path="webhook"
				element={<DashboardTemplate>Webhook</DashboardTemplate>}
			/>
		</Route>
	);
}
